import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=71bd97e3&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=71bd97e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd97e3",
  null
  
)

export default component.exports